<div class="loader" [class.loader__detailed]="detailed()" [class.loader__small]="paddingSize() === 'small'">
  <div [class.loader__center]="!detailed()" [class.loader__left]="detailed()">
    <div class="loader__circle" [class.loader__circle--small]="small()"></div>
    <div class="loader__text" [class.loader__text__detailed]="detailed()">
      @if (!iconOnly()) {
        <span>{{ "Global.Loading" | translate }}</span>
      }
      @if (detailed()) {
        <span>{{ text() }}</span>
      }
    </div>
  </div>
</div>
